import useResizeObserver from '@react-hook/resize-observer';
import debounce from 'lodash/debounce';
import React, { createContext, ReactNode, useState } from 'react';
import { BreakpointSize, getBreakpoint } from '../../hooks/breakpoints';

export const BreakpointContext = createContext<BreakpointSize>('xl');

export const BreakpointProvider = ({ children }: { children: ReactNode }) => {
    const [currentBreakpoint, setCurrentBreakpoint] = useState<BreakpointSize>(() => {
        const windowInnerWidth = window.innerWidth;
        const initialBreakpoint = getBreakpoint(windowInnerWidth);
        return initialBreakpoint;
    });

    useResizeObserver(
        window.document.documentElement,
        debounce((entry) => {
            const windowInnerWidth = entry.contentRect.width;
            const newBreakpoint = getBreakpoint(windowInnerWidth);
            setCurrentBreakpoint((prevBreakpoint) => {
                if (newBreakpoint !== prevBreakpoint) {
                    return newBreakpoint;
                }

                return prevBreakpoint;
            });
        }, 100)
    );

    return <BreakpointContext value={currentBreakpoint}>{children}</BreakpointContext>;
};
